import { React, useEffect } from 'react';
import { useState } from 'react';
import { post } from '../../util/request';
import { get } from '../../util/request';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useHistory } from 'react-router';
import { DatePickerField } from '../../components/common/form';
import { useTranslation } from 'react-i18next';
import './index.scss'
import forge from 'node-forge';
import { Image } from '../../assets';
import Loading from '../../components/common/loading.js';
const baseurl = process.env.REACT_APP_BASEPATH;


const ActivateAccount = () => {

  const history = useHistory();
  const { t,i18n } = useTranslation();
 const [lang, setLang] = useState(i18n.resolvedLanguage);
  const [isButton, setButton] = useState('')
useEffect(() => {
    if (i18n.resolvedLanguage == 'en_US') {
      setLang('en_US')
    } else if (i18n.resolvedLanguage == 'zh_HK') {
      setLang('zh-HK')
    } else if (i18n.resolvedLanguage == 'jp') {
      setLang('ja')
    } else if (i18n.resolvedLanguage == 'zh_CN') {
      setLang('zh_CN')
    }
  }, [i18n.resolvedLanguage])

  const [ischeck, setcheck] = useState(true)
  const Client = () => {
    empty()
    if (ischeck === false) {
      setcheck(!ischeck)
    }
  }
  const Other = () => {
    empty()
    if (ischeck === true) {
      setcheck(!ischeck)
    }
  }

  const [isResetPasswordChecked, setIsResetPasswordChecked] = useState(false)
  const FUsername = () => {
    empty()
    if (isResetPasswordChecked === true) {
      setIsResetPasswordChecked(!isResetPasswordChecked)
    }
  }
  const FPassword = () => {
    empty()
    if (isResetPasswordChecked === false) {
      setIsResetPasswordChecked(!isResetPasswordChecked)
    }
  }


  const [key, setkey] = useState('')




  const empty = () => {
    setdateofBirth(null)
    setlastName('')
    setemail('')
    setusername('')
  }


  const [dateofBirth, setdateofBirth] = useState(null)
  const dateofBirthChange = event => {
    setdateofBirth(event.target.value);
  };

  const [lastName, setlastName] = useState('')
  const lastNameChange = event => {
    setlastName(event.target.value);
  };


  const [email, setemail] = useState('')
  const emailChange = event => {
    setemail(event.target.value);
  };

  const [username, setusername] = useState('')
  const usernameChange = event => {
    setusername(event.target.value);
  };


  const [clientID, setclientID] = useState('')
  const clientIDChange = event => {
    setclientID(event.target.value);
  };

  const [code, setCode] = useState("");
  const [maskedEmail, setMaskedEmail] = useState("");
  const [referenceId, setReferenceId] = useState("");
  const [verified, setVerified] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setButton('');
    getkey()
  }, []);

  const passwordReset = async () => {
    setLoading(true)
    if (!username) {
      t('Please input username')
      return
    }

    setCode('');
    
    let setupdata = {
      deviceModel: "WEB",
      entry: "WEB",
      isChina: false,
      username: username,
      deviceId: "",
      deviceToken: "",
    }
    await post('/auth/password/reset',setupdata).then((data)=>{
      setReferenceId(data.referenceId)
      setMaskedEmail(data.maskedEmail)
      setVerified(false)
      setButton('success')
    }).catch((err) => {
      console.log(err.message)
      setButton('fail')
    });

    setLoading(false)
  };


  const setup = async () => {
    if (!email) {
      alert('Pls input email')
      return
    }
    if (!lastName && ischeck) {
      alert('Pls input lastName')
      return
    }
    if (!dateofBirth && ischeck) {
      alert('Pls input dateofBirth')
      return
    }
    if (!clientID && !ischeck) {
      alert('Pls input dateofBirth')
      return
    }
    var pubencryptKey = key

    let rsaPublicKey = forge.pki.publicKeyFromPem(`-----BEGIN PUBLIC KEY-----${pubencryptKey}-----END PUBLIC KEY-----`);
    let encrypted = rsaPublicKey.encrypt(clientID, 'RSA-OAEP', {
      md: forge.md.sha256.create(),
      mgf1: {
        md: forge.md.sha1.create(),
      },
    });
    let setupdata = {
      clientType: ischeck ? "CLIENT" : "BIZ",
      dob: dateofBirth,
      clientID: forge.util.encode64(encrypted),
      email: email,
      lastName: lastName,
      deviceModel: "WEB",
      entry: "WEB",
      isChina: false,
      username: username,
      deviceId: "",
      deviceToken: "",
    }
    if (dateofBirth) {
      const year = dateofBirth.getFullYear();
      const month = String(dateofBirth.getMonth() + 1).padStart(2, '0'); // 补零至两位数
      const day = String(dateofBirth.getDate()).padStart(2, '0');
      const formattedDate = `${year}/${month}/${day}`;
      setupdata.dob = formattedDate;
    }
    const data = await post('/auth/username/forgot', setupdata);
    if (!data) {
      setdateofBirth(null)
      setlastName('')
      setemail('')
      setusername('')
      setReferenceId('')
      setMaskedEmail('')
      setVerified(false)
      return
    }
    if (data.code === 0) {
      setButton('success')
    } else {

      setButton('fail')
    }

  };


  const getkey = async () => {
    let deviceId = {
      deviceId: 'Web'
    }
    const data = await get('/auth/key', deviceId);
    if (!data) {
      return
    }
    setkey(data.message)
    // encryptPassword(data.message, id)
  };
  const backtoHome = () => {
    history.push('/')
  }
  const gotoContanct = () => {
    history.push('/contactUs')
  }

  const verifyCode = async (event) => {
    setLoading(true)
    event.preventDefault();
    let setupdata = {
      deviceModel: "WEB",
      entry: "WEB",
      isChina: false,
      username: username,
      verificationCode: code,
      referenceId: referenceId,
      deviceId: "",
      deviceToken: "",
    }
    await post('/auth/password/reset/verify',setupdata).then((data)=>{
      if(data){
        setVerified(true)
      }
      else{
        setVerified(false)
      }
    }).catch((err) => {
        console.log(err.message)
    });
    setLoading(false)
  }

  const handleSetup = () => {

    if (isButton == 'success' && isResetPasswordChecked == false && verified == false) {
      return (
        <div className='content d-flex flex-column justify-content-center align-items-center'>

          <div className='m-b-32'>
            <img src={'./Combined Shape.png'} width="81" height="80" viewBox="0 0 81 80" fill="none" />

          </div>

          <div className='promote m-b-32'>{t('An email with your username information has been sent to ')} {email}</div>


          <div className=''>
            <button onClick={() => backtoHome()} type="button" class="nextBtn btn btn-outline-next">{t('Login')} </button>
          </div>

        </div>
      )
    } 
    else if (isButton == 'success' && isResetPasswordChecked == true && verified == false) {
      return (
        <div className='content d-flex flex-column justify-content-center align-items-center'>
          <img src={Image.waltonLogo} className='logo' alt="logo" />

          <div className='promote m-b-32'><h4>{t('Multi-factor Authentication')}</h4></div>

          <div className='promote m-b-32'>{t('A code has been sent to').replace('{email}', '')}
          <br></br>{maskedEmail}<br></br>
          {t('Enter code below')}<b style={{cursor: "pointer", textDecoration: "underline"}} onClick={() => passwordReset()}> {t('Send a new code')}.</b>
          </div>
          <form onSubmit={verifyCode} className='verify-code'>
                <input required type="text" value={code} class="form-control form-control-sm" onChange={(event) => setCode(event.target.value)} name="code" placeholder="Code" />
            <div className=''>
              <button type="submit" class="nextBtn btn btn-outline-next">{t('Verify Code')} </button>
            </div>
          </form>

          <div className='d-flex flex-column justify-content-center'>
          <div className='promote' style={{ color: '#5582a0' }}>
                {t('Having problems?')}
              </div>
            <button onClick={() => gotoContanct()} type="button" class="btn btn-outline-link">{t('Contact Client Services')}</button>
            <button onClick={() => backtoHome()} type="button" class="btn btn-outline-link">{t('Back home')}</button>
          </div>
        </div>
      )
    } 
    else if (isButton == 'success' && isResetPasswordChecked == true && verified == true) {
      return (
        <div className='content d-flex flex-column justify-content-center align-items-center'>

          <div className='m-b-32'>
            <img src={'./Combined Shape.png'} width="81" height="80" viewBox="0 0 81 80" fill="none" />

          </div>

          <div className='promote m-b-32'>{t('A temporary password')} {maskedEmail}</div>

          <div className=''>
          <form action={baseurl + "/auth/aad/b2c/login/page/web_v1?lang=" + lang} method="post">
                <input type="hidden" name="claims" value="emailAddress" />
                <button type="submit" className="nextBtn btn btn-outline-next" >{t('Login')}</button>
              </form>
          </div>

        </div>
      )
    } 
    else {
      return (
        <div className='content '>
          <div className='promote m-b-32 '>{t('Please enter the following information')}</div>
          <div className='usertype'>
            <p>{t('Request*')}</p>
            <div className='d-flex justify-content-between'>
              <div className='d-flex align-items-center'>
                <button className={(!isResetPasswordChecked ? 'radio radio-check' : 'radio')} onClick={() => FUsername()}>
                  <div className='check '></div>
                </button>
                {t('Email Username')}
              </div>

              <div className='d-flex align-items-center'>
                <button className={(isResetPasswordChecked ? 'radio radio-check' : 'radio')} onClick={() => FPassword()}>
                  <div className='check'></div>
                </button>
                {t('Reset Password')}
              </div>
            </div>
          </div>
          <div className={isResetPasswordChecked === true ? 'f-username display-none' : 'f-username'}>
            <div className='usertype'>
              <p>{t('User Type*')}</p>
              <div className='d-flex justify-content-between'>
                <div className='d-flex align-items-center'>
                  <button className={(ischeck ? 'radio radio-check' : 'radio')} onClick={() => Client()}>
                    <div className='check '></div>
                  </button>
                  {t('Client')}
                </div>

                <div className='d-flex align-items-center'>
                  <button className={(!ischeck ? 'radio radio-check' : 'radio')} onClick={() => Other()}>
                    <div className='check'></div>
                  </button>
                  {t('Business Partner')}
                </div>
              </div>
            </div>
            <div className='clientid'>
              {!ischeck ? (<><span>{t('Vendor ID')}*</span>
                <input value={clientID} type="text" onChange={clientIDChange} placeholder={t('Vendor ID')} className='clientid-input' /></>) : null}
              <span>{t('Registered Email Address*')}</span>
              <input value={email} onChange={emailChange} type="text" placeholder={t('Enter registered email address')} className='clientid-input' />
              {ischeck ? <>
                <span>{t('Last Name*')}</span>
                <input value={lastName} onChange={lastNameChange} type="text" placeholder={t('Enter your last name')} className='clientid-input' />
                <span>{t('Date of Birth*')}</span>
                <div className='datainput'>
                  <DatePickerField value={dateofBirth} setValue={setdateofBirth}></DatePickerField>
                </div>
              </> : null}
            </div>
            <div className='d-flex flex-column justify-content-center'>
              <button onClick={() => setup()} type="button" class="nextBtn btn btn-outline-next">{t('NEXT')}</button>
            </div>
          </div>
          <div className={isResetPasswordChecked === false ? 'f-password display-none' : 'f-password'}>
            <div className='clientid'>
              
                <span>{t('Username')+'*'}</span>
                <input value={username} onChange={usernameChange} type="text" placeholder={t('Enter your username')} className='clientid-input' />
                
            </div>
            <div className='d-flex flex-column justify-content-center'>
              <button onClick={() => passwordReset()} type="button" class="nextBtn btn btn-outline-next">{t('NEXT')}</button>
              
            </div>
          </div>

          <div className='d-flex flex-column justify-content-center'>
          <div className='promote' style={{ color: '#5582a0' }}>
                {t('Having problems?')}
              </div>
            <button onClick={() => gotoContanct()} type="button" class="btn btn-outline-link">{t('Contact Client Services')}</button>
            <button onClick={() => backtoHome()} type="button" class="btn btn-outline-link">{t('Back home')}</button>
          </div>

        </div>
      )
    }

  }


  return (
    <div className='activateAccount'>
      {loading ? <Loading /> : null}
      <div className='d-flex justify-content-between align-items-center headline-box'>
        <div className='line'>
        </div>
        <h1 className='headline'>

          {isButton == 'success' ? t('Forgot Username') : <></>}
          {isButton == 'fail' ? t('Invalid information') : <></>}
          {isButton == '' ? t('Forgot Username') : <></>}
        </h1>
        <div className='line'>
        </div>
      </div>
      <div className='main-box'>
        <div className='content-box'>
          {/* <div className='content'>
              <div className='promote m-b-32'>Please enter the following information and the email address that you used to register.We'll send you an email with your username</div>

                <div>
                  <div className='usertype'>
                <p>User type*</p>
                <div className='d-flex justify-content-between'>
                  <div className='d-flex align-items-center'>
                    <button className={(ischeck ? 'radio radio-check' : 'radio')} onClick={() => Client()}>
                      <div className='check '></div>
                    </button>
                    Email
                  </div>

                  <div className='d-flex align-items-center'>
                    <button className={(!ischeck ? 'radio radio-check' : 'radio')} onClick={() => Other()}>
                      <div className='check'></div>
                    </button>
                    Business Partner
                  </div>
                </div>
              </div>
                    <div className='clientid'>
                      <span>Registered Email Address</span>
                      <input value={email} onChange={emailChange} type="text" placeholder="Enter email" className='clientid-input' />
                      <span>Last Name</span>
                      <input value={lastName} onChange={lastNameChange} type="text" placeholder="Enter Last Name" className='clientid-input' />
                      <span>Date of Birth</span>
                      <div className='datainput'>
                        <DatePickerField value={dateofBirth} setValue={setdateofBirth}></DatePickerField>
                      </div>
                    </div> 
                </div>
              <div className='d-flex flex-column justify-content-center'>
                <button onClick={() => setup()} type="button" class="nextBtn btn btn-outline-next">NEXT</button>
                <button onClick={() => backtoHome()} type="button" class="btn btn-outline-link">Back Home</button>
              </div>

            </div> */}
          {handleSetup()}
        </div>

      </div>
    </div>
  );
};
export default ActivateAccount;
